import React from "react";
import styled from "styled-components";

const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  width: 100%;
  padding: 100px 400px 80px;
  background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
  text-align: center;
  z-index: 3;

  h2 {
    font-size: 40px;
    font-weight: 600;
    line-height: 1.4;
    color: #1a1a1a;
    margin: 0;

    strong {
      background: linear-gradient(90deg, #5c6eff, #7a8cff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 700;
    }
  }

  p {
    font-size: 25px;
    line-height: 180%;
    color: #444;

    .lead {
      font-size: 30px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    strong {
      font-weight: 600;
      color: #5c6eff;
    }
  }

  /* 은은한 블루빛 배경 효과 */
  &::after {
    content: "";
    position: absolute;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(92, 110, 255, 0.1), transparent 70%);
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
  }

  /* 반응형 처리 */
  @media (max-width: 1400px) {
    padding: 80px 200px 60px;
    
    h2 {
      font-size: 36px;
    }
    
    p {
      font-size: 22px;
      
      .lead {
        font-size: 26px;
      }
    }
    
    &::after {
      width: 400px;
      height: 400px;
    }
  }

  @media (max-width: 1200px) {
    padding: 70px 100px 50px;
    gap: 28px;
    
    h2 {
      font-size: 32px;
      line-height: 1.3;
    }
    
    p {
      font-size: 20px;
      line-height: 170%;
      
      .lead {
        font-size: 24px;
      }
    }
    
    &::after {
      width: 350px;
      height: 350px;
    }
  }

  @media (max-width: 768px) {
    padding: 60px 40px 40px;
    gap: 24px;
    
    h2 {
      font-size: 28px;
      line-height: 1.3;
    }
    
    p {
      font-size: 18px;
      line-height: 160%;
      
      .lead {
        font-size: 20px;
        margin-bottom: 6px;
      }
    }
    
    &::after {
      width: 300px;
      height: 300px;
    }
  }

  @media (max-width: 480px) {
    padding: 50px 20px 30px;
    gap: 20px;
    
    h2 {
      font-size: 24px;
      line-height: 1.4;
    }
    
    p {
      font-size: 16px;
      line-height: 150%;
      
      .lead {
        font-size: 18px;
        margin-bottom: 4px;
      }
    }
    
    &::after {
      width: 250px;
      height: 250px;
    }
  }
`;

const ProblemSolutionSection: React.FC = () => {
  return (
    <Section>
      <h2>
        <strong>음성 AI</strong>로, <strong>비즈니스 성장</strong>의 속도를 높이세요.
      </h2>

      <p>
  <span className="lead">
    복잡한 기술 대신, <strong>실질적인 성장</strong>에 집중할 시간.
  </span>
  <br />
  오디온은 <strong>음성 AI</strong> 도입의 모든 과정을 쉽게 만들어, <br />
  <strong>더 나은 고객 경험</strong>과 <strong>효율</strong>을 실현합니다. <br />
  <strong>빠른 도입</strong>과 <strong>혁신</strong>으로, <strong>매출과 경쟁력</strong>을 동시에 잡으세요.
</p>
    </Section>
  );
};

export default ProblemSolutionSection;